<div style="padding: 24px;">
    <h5 class="form-heading">
        Refer a Friend
        <a>
            <i class="fa fa-times float-right pt-2 mt-1" (click)="cancel()"></i>
        </a>
    </h5>
    <form [formGroup]="resume_referral">
        <div class="row">
            <div class="col-md-12 col-sm-12 pt-1 pb-1">
                <div class="row ">
                    <div class="col-md-12">
                        <label class="mb-1 document" style="   color: black;
                        font-size: 13px;
                        font-weight: 500;">Resume Document
                            <span style="color: red !important;">*</span>
                        </label>
                    </div>
                    <div class="col-md-12 form-group mb-4 mt-1" style="text-align: center;">
                        <app-files-duplicate [flag]="1" class="form-control" (returnFiles)="saveFileResult($event)" class="form-control" [result]="resume_details.resume_document"></app-files-duplicate>
                    </div>
                </div>
                <div class="row ">
                    <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>First Name</mat-label>
                            <input name="Title" class="w-93" id="first" matInput placeholder="First Name" (keydown)="inputText($event,100)" formControlName="first_name"
                                [required]="true">
                            <mat-error *ngIf="resume_referral.controls.first_name.errors">
                                <div *ngIf="resume_referral.controls.first_name.errors.required">First Name is required
                                </div>
                                <div *ngIf="resume_referral.controls.first_name.errors.minlength">First Name must be at least 1 character</div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Last Name</mat-label>
                            <input name="last" class="w-93" matInput placeholder="Last Name" (keydown)="inputTextMaxNull($event)" formControlName="last_name">
                            <!-- <mat-error *ngIf="resume_referral.controls.last_name.errors">
                                <div *ngIf="resume_referral.controls.last_name.errors.required">First Name is
                                    required</div>
                                <div *ngIf="resume_referral.controls.last_name.errors.minlength">First Name must be
                                    at least 1 character</div>
                            </mat-error> -->
                        </mat-form-field>
                    </div>

                </div>
                <!-- <div class="row ">
                <div class="col-md-12 form-group">
                    <mat-form-field floatLabel="always">
                        <mat-label>Last Name</mat-label>
                        <input name="last" class="w-93" matInput placeholder="Last Name"
                            (keydown)="inputText($event)" formControlName="last_name">
                        <mat-error *ngIf="resume_referral.controls.last_name.errors">
                            <div *ngIf="resume_referral.controls.last_name.errors.required">First Name is
                                required</div>
                            <div *ngIf="resume_referral.controls.last_name.errors.minlength">First Name must be
                                at least 1 character</div>
                        </mat-error>
                    </mat-form-field>
                </div>

            </div> -->

                <div class="row ">
                    <div class="col-md-12 form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Email ID</mat-label>
                            <input name="email" class="w-93" matInput placeholder="test@example.com" formControlName="email_id" [required]="true" (keydown)="inputEmail($event)">
                            <mat-error *ngIf="resume_referral.controls.email_id.errors">
                                <div *ngIf="resume_referral.controls.email_id.errors.required">Email ID is required
                                </div>
                                <div *ngIf="resume_referral.controls.email_id.errors.pattern">Enter valid Email</div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6  form-group">
                        <!-- <mat-form-field floatLabel="always">
                        <mat-label>Country Code</mat-label>
                        <mat-select name="form-code" placeholder="< - - Select - - >" formControlName="mobile_no_cc"  [required]="true">
                            <input [(ngModel)]="search" [ngModelOptions]="{standalone: true}" type="text" name="" id=""
                            placeholder="Search" class="form-control">
                            <mat-option *ngFor="let section of isd| filter:search" [value]="section.isd_code">
                                {{section.isd}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field> -->
                        <app-select-search [mandatory]="true" [options]="isd" [form_group]="resume_referral" form_control="mobile_no_cc" title_property="isd"
                            id_property="isd_code" placeholder="Country Code" float_label="always" label="Country Code" float_label="always"
                            [selected_input]="resume_referral.value.mobile_no_cc" (selected_obj)="selected_obj($event)">
                        </app-select-search>
                    </div>

                    <div class="col-md-6  form-group">
                        <mat-form-field floatLabel="always">
                            <mat-label>Mobile Number</mat-label>
                            <input name="phone" class="w-93" type="number" matInput placeholder="Mobile Number" formControlName="mobile_no" [required]="true"
                                (keydown)="inputNumber($event)">
                            <mat-error *ngIf="resume_referral.controls.mobile_no.errors">
                                <div *ngIf="resume_referral.controls.mobile_no.errors.required">Mobile Number is required
                                </div>
                                <div *ngIf="resume_referral.controls.mobile_no.errors.min">Please enter {{mobile_number_length}} digit Mobile Number</div>
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>

                <div class="row mt-1">
                    <div class="col-md-12 ">
                        <button [disabled]="loading" class="float-right  ml-1 btn btn-sm btn-primary w-100" (click)="save()">
                            <div *ngIf="loading" style="text-align: center;">
                                <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
                            </div>
                            <span *ngIf="!loading">
                                Refer
                            </span>
                        </button>
                        <!-- <button class="float-right ml-auto btn btn-sm btn-danger" (click)="cancel()">
                        Cancel
                    </button> -->
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>